import styled from 'styled-components';
import { primary, neutral, white } from '../../../../style/colors';

export const SectionContainer = styled.div`
  background-color: ${white};
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid ${neutral[200]};
  transition: all 0.2s;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: ${primary[500]};
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 4px 0;
  font-weight: 700;
  font-size: 14px;
  color: ${neutral[900]};
  user-select: none;

  &:hover {
    color: ${primary[500]};
  }

  i {
    font-size: 20px;
    color: ${primary[500]};
    transition: transform 0.3s ease;
    transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
`;

export const SectionContent = styled.div`
  padding-top: ${(props) => (props.isOpen ? '12px' : '0')};
  max-height: ${(props) => (props.isOpen ? '400px' : '0')};
  overflow-y: auto;
  overflow-x: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
  
  /* Custom scrollbar - subtle neutral */
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${neutral[300]};
    border-radius: 2px;
  }
`;
